import { HTTP_INTERCEPTORS, HttpBackend, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { RECAPTCHA_BASE_URL } from 'ng-recaptcha-2';
import { OrderByPipe } from 'ngx-pipes';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthGuard } from './guards/auth.guard';
import { MaintenanceGuard } from './guards/maintenance.guard';
import { InstanaErrorHandler } from './instana-error-handler';
import { UsersService } from './modules/self-service/services/users.service';
import { SnackbarModule } from './modules/shared/snackbar/snackbar.module';
import { AuthService } from './services/auth.service';
import { ConfigService } from './services/config.service';
import { InterceptorService } from './services/interceptor.service';
import { StatusPageService } from './services/status-page.service';
import { TranslationConfigService } from './services/translation-config.service';
import { replaceDomainUrl } from 'src/environments/environment.model';

function HttpLoaderFactory(http: HttpBackend) {
    return new MultiTranslateHttpLoader(http, [
        // CSS translations
        {
            prefix: `${environment.http.translationsBaseUrl}phraseapp-proxy/projects/5c4867f64b2f6029d7070a82f1baef11/locales/`,
            suffix: '/download?file_format=i18next',
        },
        // @vi-succ/design-system-web translations
        {
            prefix: `${environment.http.translationsBaseUrl}phraseapp-proxy/projects/ec38b083a23c58c604a49d7f443dd7f2/locales/`,
            suffix: '/download?file_format=simple_json',
        },
    ]);
}

@NgModule({
    declarations: [AppComponent],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpBackend],
            },
            isolate: false,
        }),
        SnackbarModule,
    ],
    providers: [
        TranslationConfigService,
        {
            provide: ErrorHandler,
            useClass: InstanaErrorHandler,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: InterceptorService,
            multi: true,
        },
        AuthService,
        AuthGuard,
        MaintenanceGuard,
        StatusPageService,
        {
            provide: RECAPTCHA_BASE_URL,
            useValue: 'https://recaptcha.net/recaptcha/api.js',
        },
        UsersService,
        ConfigService,
        OrderByPipe,
        provideHttpClient(withInterceptorsFromDi()),
    ],
})
export class AppModule {
    constructor() {}
}
